// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b4108de7","239":"7081a08c","455":"95d3a7f8"}[chunkId] + ".chunk.js";
};